// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baloa-pro-cancel-subscription-modal .modal__container {
    width: 397px;
    padding: 0;
    margin: 0;
}

.baloa-pro-cancel-subscription-modal .modal__container__close {
    width: 13px;
    height: 13px;
}

.baloa-pro-cancel-subscription-modal__title.baloa-normal-medium {
    color: var(--primary-very-dark-color);
    margin-top: 44px;
    padding: 0 18px;
}

.baloa-pro-cancel-subscription-modal__message.baloa-table {
    color: var(--primary-dark-color);
    margin-top: 24px;
    padding: 0 18px;
}

.baloa-pro-cancel-subscription-modal__message strong {
    font-weight: var(--font-medium);
}

.baloa-pro-cancel-subscription-modal__buttons {
    margin-top: 25px;
    border-top: 1px solid var(--new-input-background-color);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 8px;
}

.baloa-pro-cancel-subscription-modal__cancel-button.button.small{
    color: var(--basic-gray-color);
    padding: 8px 20px;
}

.baloa-pro-cancel-subscription-modal__buttons .primary-button.button.small {
    padding: 8px 20px;
    margin-left: 26px;
    background-color: var(--error-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    
    .baloa-pro-cancel-subscription-modal .modal__container {
        width: 100%;
        margin: 20px;
    }

    .baloa-pro-cancel-subscription-modal__title.baloa-normal-medium {
        font-size: 19px;
        line-height: normal;
    }

    .baloa-pro-cancel-subscription-modal__message.baloa-table  {
        font-size: 16px;
        line-height: normal;
    }

    .baloa-pro-cancel-subscription-modal__buttons .button.small {
        font-size: 15px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/baloa-pro/components/baloa-pro-cancel-subscription-modal/BaloaProCancelSubscriptionModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,UAAU;IACV,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,uDAAuD;IACvD,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,oCAAoC;AACxC;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".baloa-pro-cancel-subscription-modal .modal__container {\n    width: 397px;\n    padding: 0;\n    margin: 0;\n}\n\n.baloa-pro-cancel-subscription-modal .modal__container__close {\n    width: 13px;\n    height: 13px;\n}\n\n.baloa-pro-cancel-subscription-modal__title.baloa-normal-medium {\n    color: var(--primary-very-dark-color);\n    margin-top: 44px;\n    padding: 0 18px;\n}\n\n.baloa-pro-cancel-subscription-modal__message.baloa-table {\n    color: var(--primary-dark-color);\n    margin-top: 24px;\n    padding: 0 18px;\n}\n\n.baloa-pro-cancel-subscription-modal__message strong {\n    font-weight: var(--font-medium);\n}\n\n.baloa-pro-cancel-subscription-modal__buttons {\n    margin-top: 25px;\n    border-top: 1px solid var(--new-input-background-color);\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    padding: 8px;\n}\n\n.baloa-pro-cancel-subscription-modal__cancel-button.button.small{\n    color: var(--basic-gray-color);\n    padding: 8px 20px;\n}\n\n.baloa-pro-cancel-subscription-modal__buttons .primary-button.button.small {\n    padding: 8px 20px;\n    margin-left: 26px;\n    background-color: var(--error-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    \n    .baloa-pro-cancel-subscription-modal .modal__container {\n        width: 100%;\n        margin: 20px;\n    }\n\n    .baloa-pro-cancel-subscription-modal__title.baloa-normal-medium {\n        font-size: 19px;\n        line-height: normal;\n    }\n\n    .baloa-pro-cancel-subscription-modal__message.baloa-table  {\n        font-size: 16px;\n        line-height: normal;\n    }\n\n    .baloa-pro-cancel-subscription-modal__buttons .button.small {\n        font-size: 15px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
